// import { setCookie } from '../utils';

const mutations  = {
	SET_VIP_LEVEL (state, status) {
		state.vipLevel = status
	},
	SET_LOGIN_INFO (state, data) {
		if(data.birth){
			data.birth = data.birth.replace(/(\.)/g, '-')
		}
		for (const key in data) {
			state[key] = data[key]
			if(key==='vipLevel'){
				localStorage.setItem('vipLevel',data[key])
				// eslint-disable-next-line
				sensors.registerPage({
					is_vip: Number(data[key]) ? true : false
				});
			}
		}
    },
	SET_PERSON (state, data) {
		for (const key in data) {
			state[key] = data[key]
		}
	},
	HAS_EDITNAME(state) {
		state['defaultUserName'] = false
	},
	SET_POLICY_SECRETARY(state, data) {
		state['policySecretary'] =  data
	},
	SET_VIP(state, data) {
		state['vipEndTime'] =  data.vipEndTime
		state['timeLenStr'] = data.timeLenStr
		state['vipLevel'] = 1
		localStorage.setItem('vipLevel', '1')
		// eslint-disable-next-line
		sensors.registerPage({
			is_vip: true
		});
	},
	SET_DISCOUPONNUMBER(state, data){
		state['notAvailableCouponNum'] =  data
	},
	SET_MESSAGELIST(state, list) {
		state['messageList'] =  list
	},
	SET_LEFTVISITTIMES (state, data) {
		state.policyLeftVisitTimes = data
	},
}

export default mutations
